module.exports = __webpack_public_path__ + "static/assets/3ea6fb98b15e90ee1315cd188d2eadf4.png";